import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox, FDIcon, FDStack, FDTitleText,
} from '@facet-wealth/design';

const TitleWithIcon = ({ icon, title }) => {
  const hasIcon = icon !== undefined;
  return (
    <FDStack spacing={1.5} alignItems="center" justifyContent="flex-start">
      {hasIcon && <FDIcon icon={icon} color="primary" />}
      <FDBox width="250px">
        <FDTitleText size="lg" value={title ?? ''} />
      </FDBox>
    </FDStack>
  );
};

TitleWithIcon.defaultProps = {
  icon: undefined,
};

TitleWithIcon.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default TitleWithIcon;
